import React from 'react';
import BaseProps from "../../types/BaseProps";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Icon from "../../common/Icon";
import Alert from "react-bootstrap/Alert";
import classNames from "classnames";

import "./AlertError.scss";

type AlertErrorProps = BaseProps;

export default class AlertError extends React.Component<AlertErrorProps> {

  render() {
    const classes = classNames("AlertError", this.props.className);
    return (
      <Alert variant="danger" className={classes}>
        <Container fluid className="no-padding">
          <Row>
            <Col md="auto" className="IconCol">
              <Icon icon="exclamation-triangle" size="2x"/>
            </Col>
            <Col>
              {this.props.children}
            </Col>
          </Row>
        </Container>
      </Alert>
    );
  }
}
